// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"Sidebar_sidebarContainer__TJCFT","sticky":"Sidebar_sticky__uvMNO","almostDoneContainer":"Sidebar_almostDoneContainer__3pAdQ"};